import classNames from 'classnames'
import { inject } from 'helpers/mobx'
import React from 'react'

import {
  RecoSectionContent,
  TrackingPageTypeWithoutId,
} from '@aboutyou/legacy-tracking-sdk'
import Carousel from 'components/Carousel'
import OutfitTile from 'components/OutfitTile'
import { getGenderUrl } from 'helpers/gender'
import { RecoSliderSectionTrackingContextProvider } from 'helpers/tracking/SectionTrackingContext'
import { Link } from 'react-router-dom'
import { TranslateFnType } from 'store'
import EntityStore from 'store/entities'
import Outfit from 'store/entities/Outfit/Outfit.store'
import * as styles from './styles.module.scss'

interface IProps {
  outfit?: Outfit
  headline?: string
  outfitIds: string[]
  outfits?: Outfit[]
  slidesToShow?: number
  slidesToScroll?: number
  customStyles?: object
  showIdolImage?: boolean
  outfitsUrl?: string
  entityStore: EntityStore
  t: TranslateFnType
  dataTestId?: string
  isRTL?: boolean
  pageType: TrackingPageTypeWithoutId | null
}
class OutfitSlider extends React.Component<IProps, any> {
  renderProducts() {
    if (this.props.outfitIds) {
      const outfitIds = this.props.outfitIds.filter(id => {
        const outfit = this.props.entityStore.outfits[id]
        return outfit && outfit.idol
      })

      return outfitIds.map(outfitId => (
        <div key={outfitId} className={styles.tile}>
          <OutfitTile
            id={outfitId}
            showIdolImage={this.props.showIdolImage}
            pageType={this.props.pageType}
          />
        </div>
      ))
    }
  }

  render() {
    const { t, outfit, dataTestId } = this.props
    const headline = outfit
      ? t('Mehr Outfits von {{idolName}}', {
          idolName: outfit.idol && outfit.idol.name,
        })
      : this.props.headline

    return (
      <RecoSliderSectionTrackingContextProvider
        recoType={RecoSectionContent.outfitRecoSlider}
      >
        <div className={styles.sliderWrapper} data-testid="OutfitSlider">
          {(outfit || this.props.headline) && (
            <div className="row bottom-sm">
              <div className="col-sm-6">
                <h3 className={styles.headline}>{headline}</h3>
              </div>
              <div className={classNames(styles.cta, 'col-sm-6')}>
                <Link to={this.props.outfitsUrl || ''}>
                  {t('Alle Outfits')}
                </Link>
              </div>
            </div>
          )}
          <Carousel
            slidesToShow={this.props.slidesToShow || 3}
            slidesToScroll={this.props.slidesToScroll || 3}
            alignLeft
            dataTestId={dataTestId || 'OutfitSlider'}
            isRTL={this.props.isRTL}
          >
            {this.renderProducts()}
          </Carousel>
        </div>
      </RecoSliderSectionTrackingContextProvider>
    )
  }
}

export default inject(
  store => {
    const gender = store.userStore.gender
    const { locale } = store.localeStore
    const t = store.t
    return {
      t,
      outfitsUrl: `/${getGenderUrl(locale)(gender)}/outfits`,
      entityStore: store.entityStore,
    }
  },
  { observe: true },
)(OutfitSlider)
